import React, { useEffect } from 'react';
import moment from 'moment';
import { Collapse } from 'antd';
import FilterComponent from '../../../children/FilterComponent/FilterComponent';
import { FEEDBACK_360_TYPE_NON_COHORT } from '../../../../../../../config/questionTypeConstants';
import { BUTTON_NAME, HEADER_TEXT } from './constants';
import { buildBenchmarkFiltersPayload } from '../../utils/buildBenchmarkFiltersPayload';
import { getDataFromUrlToken } from '../../../../../../utils/urlDataStore';
import { URL_DATA } from '../../../../../../../config/urlDataConstants';
import { toast } from '../../../../../../utils/messageUtils';
import SectionHeader from '../SectionHeader';
import SVGIcons from '../../../../../../Components/SVGIcons';
import { MIN_LEADERS_REQUIRED } from '../InsufficientSelectionNotice/constants';


const FilterSection = (props) => {
    useEffect(() => {
        // surveys defaults to [] on first load, and the backend treats an empty
        // surveys filter as "no filter" (fetches every leader in the org), not
        // "zero leaders" — so this guard isn't just the confidentiality-suppression
        // check (see InsufficientSelectionNotice), it's also what stops the very
        // first mount from silently requesting the whole org's data.

        if (!props.isSurveyListFetched) {
            const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
            // getOrgRaterGroups and fetchSurveysFromTheOrg run in parallel; whether
            // to call the visualization APIs depends on both results, so track each
            // outcome and only decide once the second one has landed.
            let raterGroupsResult;
            let surveyListResult;

            const tryCallVisualizationApis = () => {
                if (raterGroupsResult === undefined || surveyListResult === undefined) return;

                const hasEnoughLeaders =
                    surveyListResult.data
                    && surveyListResult.data.data.totalChildProjects > 10;

                if (hasEnoughLeaders && !props.isVisualizationDataFectched) {
                    callVisualizationApis()
                }
                else {
                    props.setInsufficientNotice(true)
                }
            };
            props.getOrgRaterGroups({}, (isSuccess, data) => {
                raterGroupsResult = { isSuccess, data };
                if (isSuccess) {
                    tryCallVisualizationApis();
                }

            })

            props.fetchSurveysFromTheOrg({ projectTypes: FEEDBACK_360_TYPE_NON_COHORT, size: orgDetails.projectCount + 10 }, (isSuccess, data) => {
                surveyListResult = { isSuccess, data };
                if (isSuccess) {
                    tryCallVisualizationApis();

                }
            })

        }
    }, [])

    const [collapseActiveKey, setCollapseActiveKey] = React.useState(['0']);

    const header = (
        <div
            className='filter-header'
        >
            <span className='filter-header__left'>
                <span className='filter-header__icon'>
                    <SVGIcons type='SVG-filter' />
                </span>
                <span className='filter-header__subhead'>Filters</span>
            </span>
            <span
                className='filter-header__sideopen'
            >
                {Array.isArray(collapseActiveKey) && collapseActiveKey.length > 0 ? 'Hide filters' : 'Show filters'}
            </span>
        </div >
    );

    const callVisualizationApis = () => {
        let payload = buildBenchmarkFiltersPayload(props.benchmarkFiltersAnalysis)
        props.getBenchmarkKpiTiles(payload)
        props.getCantAnswerResponses(payload)
        props.getDevAndStrengthVisualization(payload)
        props.getTopStrengthTopDev(payload)
        props.getTotalFeedbackProviders(payload)
        props.getRaterHeatmap(payload)
        props.getSelfVsOthers(payload)
        props.getDistributionStrip(payload)
        props.getBenchmarkAlignmentScore(payload)
        props.getRankDelta(payload)
        props.getBenchmarkTaxonomy(payload)


    }

    const handleApply = () => {
        if (props.benchmarkFiltersAnalysis && props.benchmarkFiltersAnalysis.surveys.length > 0) {
            setCollapseActiveKey([]);
            // Below the minimum leader count, InsufficientSelectionNotice takes over
            // the results area, so there's nothing to fetch yet.
            if (props.benchmarkFiltersAnalysis.surveys.length >= MIN_LEADERS_REQUIRED) {
                props.setInsufficientNotice(false)
                callVisualizationApis()

            }
            else {
                props.setInsufficientNotice(true)
            }
        }
        else {
            props.setInsufficientNotice(true)
        }

    };


    const onCustomRangeChange = (range, date, dd) => {
        // When both dates are selected, set the custom range and clear any preset
        if (range && range[0] && range[1]) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: date, preset: "" } } })
            return;
        }

        // When cleared (RangePicker X button), reset the custom range and preset
        if (!range) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: [], preset: "" } } })
        }
    };

    const handleChangeFilterValues = (eventDetails) => {
        props.handleChangeBenchmarkFilter({ changedItem: eventDetails })


    }

    const getTotalProjectCount = () => {
        if (props.fetchSurveyLists.data && props.fetchSurveyLists.data.totalChildProjects) {
            if (props.fetchSurveyLists.data.totalNonCohortProjects) {
                return props.fetchSurveyLists.data.totalChildProjects + props.fetchSurveyLists.data.totalNonCohortProjects
            }
            return props.fetchSurveyLists.data.totalChildProjects
        }
        else return 0
    }



    return (
        <>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />
            <div className='filter-sectionWrapper'>
            <Collapse
                expandIconPosition="right"
                activeKey={collapseActiveKey}
                onChange={setCollapseActiveKey}
            >
                <Collapse.Panel header={header} key="0">
                    <FilterComponent
                            availableRaterGroups={props.fetchOrgRaterGroupsApi.data && props.fetchOrgRaterGroupsApi.data.ratersList ? props.fetchOrgRaterGroupsApi.data.ratersList : []}
                            isError={props.fetchSurveyLists.error || props.fetchOrgRaterGroupsApi.error}
                            loader={props.fetchSurveyLists.isProcessing || props.fetchOrgRaterGroupsApi.isProcessing}
                        surveyList={props.fetchSurveyLists.data && props.fetchSurveyLists.data.data ? props.fetchSurveyLists.data.data : []}
                        totalCount={getTotalProjectCount()}
                        buttonName={BUTTON_NAME}
                        handleChangeFilterValues={handleChangeFilterValues}
                        dateFields={props.benchmarkFiltersAnalysis.date}
                        surveyField={props.benchmarkFiltersAnalysis.surveys}
                        raterGroups={props.benchmarkFiltersAnalysis.raterGroups}
                        onCustomRangeChange={onCustomRangeChange}
                        surveyNames={props.benchmarkFiltersAnalysis.surveyNames}
                        handleApply={handleApply}
                    />
                </Collapse.Panel>
            </Collapse>
        </div>
        </>
    );
};

export default FilterSection;

